import React from 'react';
import './CoachingStyleSaved.css';

interface SliderValue {
  id: string;
  label: string;
  value: number;
}

interface CoachingStyleSavedProps {
  sliderValues: Record<string, number>;
  sliderLabels: Record<string, string>;
}

const CoachingStyleSaved: React.FC<CoachingStyleSavedProps> = ({ 
  sliderValues, 
  sliderLabels 
}) => {
  // Map slider IDs to human-readable labels (Dec 2025: warmth merged into
  // energy; Apr 2026: Technical Depth added as 5th onboarding slider).
  const getSliderLabel = (sliderId: string): string => {
    const labelMap: Record<string, string> = {
      energy: 'Energy & Warmth',
      data_depth: 'Data Depth',
      challenge: 'Challenge',
      humor: 'Humor',
      technical_language_depth: 'Technical Depth',
    };
    return labelMap[sliderId] || sliderLabels[sliderId] || sliderId;
  };

  // Get dynamic description based on slider value (1-5 scale)
  const getDynamicDescription = (sliderId: string, value: number): string => {
    const descriptions: Record<string, Record<number, string>> = {
      energy: {
        1: 'Calm',
        2: 'Steady',
        3: 'Moderate',
        4: 'Energetic',
        5: 'Enthusiastic'
      },
      data_depth: {
        1: 'Simple',
        2: 'Basic',
        3: 'Moderate',
        4: 'Detailed',
        5: 'Deep Dives'
      },
      challenge: {
        1: 'Gentle',
        2: 'Supportive',
        3: 'Moderate',
        4: 'Challenging',
        5: 'Push Hard'
      },
      humor: {
        1: 'Professional',
        2: 'Serious',
        3: 'Moderate',
        4: 'Playful',
        5: 'Fun & Playful'
      },
      technical_language_depth: {
        1: 'Everyday',
        2: 'Foundational',
        3: 'Intermediate',
        4: 'Technical',
        5: 'Scientific'
      }
    };

    // Clamp value to 1-5 range and round to nearest integer
    const clampedValue = Math.max(1, Math.min(5, Math.round(value)));
    return descriptions[sliderId]?.[clampedValue] || 'Moderate';
  };

  return (
    <div className="coaching-style-saved">
      <div className="coaching-style-saved-header">
        <h3 className="coaching-style-saved-title">Coaching Style Saved</h3>
      </div>
      
      <div className="coaching-style-saved-content">
        {Object.entries(sliderValues).map(([sliderId, value]) => (
          <div key={sliderId} className="coaching-style-attribute">
            <span className="attribute-label">
              {getSliderLabel(sliderId)}:
            </span>
            <span className="attribute-description">
              {getDynamicDescription(sliderId, value)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoachingStyleSaved;
